import React, { useContext } from 'react'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import { RadioStepOption } from '@f/applications/QuizApp/partials/composeTileOptions'
import QuestionHeading from '@f/applications/QuizApp/partials/QuestionHeading'
import { QuizStep } from '@f/applications/QuizApp/partials/types'
import { QuestionRadioButton } from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioButton'
import { BarTile } from '@f/elements/BarTile/BarTile'

const apartmentChosenOptions: RadioStepOption[] = [
  {
    value: 'penthouse',
    label: 'Dachgeschoss'
  },
  {
    value: 'apartment',
    label: 'Etagenwohnung'
  },
  {
    value: 'apartment',
    label: 'Erdgeschoss'
  },
  {
    value: 'apartment',
    label: 'Andere'
  }
]

const houseChosenOptions: RadioStepOption[] = [
  {
    value: 'single_family_house',
    label: 'Einfamilienhaus'
  },
  {
    value: 'duplex_or_triplex',
    label: 'Doppelhaushälfte'
  },
  {
    value: 'mid_terrace_house',
    label: 'Reihenhaus'
  },
  {
    value: 'multi_family_house',
    label: 'Mehrfamilienhaus'
  },
  {
    value: 'single_family_house',
    label: 'Andere'
  }
]

export const QuestionPropertySubtype = ({ step }) => {
  const context = useContext(QuizContext)
  const propertyType = context?.data?.steps?.find(
    (s: QuizStep) => s.id === 'property_type'
  )?.values?.[0]?.value

  const options =
    propertyType === 'house' || propertyType === 'other'
      ? houseChosenOptions
      : apartmentChosenOptions
  const questionOptions = options.map(option => ({
    ...option,
    ItemTemplate: radio => <BarTile label={radio.label} />
  }))

  const handleChange = (value: string) => {
    const defaultIndicates = ['funnel-step-change']

    const indicates = step.indicates || defaultIndicates

    window._wt({
      category: 'form',
      action: 'submit',
      location: `question-${step._wtName}`,
      indicates,
      values: [
        {
          type: step._wtName,
          value
        }
      ],
      ...context.tracking.flow
    })

    context.actions.updateValues({
      stepID: step.id,
      valuesToSave: [
        {
          name: step.values[0].name,
          value: value
        }
      ]
    })

    context.actions.move({ to: 'next', triggerSubmit: false })
  }

  const heading =
    propertyType === 'house' || propertyType === 'other'
      ? 'Um was für ein Haus handelt es sich?'
      : 'Um was für eine Wohnung handelt es sich?'

  return (
    <>
      <QuestionHeading heading={heading} />
      <div className='[ f-m-h-auto ] QuestionRadio-wrap has-four-elements'>
        <div className='[ f-d-flc ] QuestionRadio-options'>
          <div className='QuestionRadio-bar-tiles'>
            {questionOptions.map(({ ItemTemplate, ...option }) => (
              <QuestionRadioButton
                key={option.value}
                wtData={{
                  location: `question-${step._wtName}`,
                  ...context.tracking.flow
                }}
                onClick={() => handleChange(option.value as string)}>
                <ItemTemplate {...option} />
              </QuestionRadioButton>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
